<template>
  <div class="tree">
    <div class="search" v-if="isSearch">
      <el-input
        class="gray white"
        :placeholder="placeholder"
        prefix-icon="el-icon-search"
        v-model="filterText"
        clearable
      >
      </el-input>
    </div>
    <el-tree
      ref="tree"
      node-key="id"
      :filter-node-method="filterNode"
      :data="companyList"
      :props="defaultProps"
      :highlight-current="true"
      :default-expanded-keys="[id]"
      :current-node-key="id"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <span v-if="data.children" class="iconfont" style="margin-right: 16px">
            <img :src="data.img">
          </span>
          <span v-else class="children-img" style="margin-right: 16px">
            <img :src="data.img">
          </span> 
          <span>{{ node.label}}</span>     
        </span>
        <span class="threeSpotImg" v-if="data.label == '出差审批单'&& data.level === 1">
          <span class="system-preset">系统预设</span>
        </span>     
      </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  props: {
    departmentId: {
      type: Number
    },
    companyList: {
      type: Array
    },
    isSwitchImg: {
      type: Boolean,
      default: true
    },
    /* 是否启用搜索 */
    isSearch: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '搜索部门名'
    },
    firstImg: {
      type: String,
      default: require('../assets/tree/first.png')
    },
    firstHighImg: {
      type: String,
      default: require('../assets/tree/first-high.png')
    },
    secondImg: {
      type: String,
      default: require('../assets/tree/second.png')
    },
    secondHighImg: {
      type: String,
      default: require('../assets/tree/second-high.png')
    },
    threeSpotImg: {
      type: String,
      default: require('../assets/tree/three-spot.png')
    },
    threeSpotHighImg: {
      type: String,
      default: require('../assets/tree/three-spot-high.png')
    },
    bookImg: {
      type: String,
      default: require('../assets/tree/book.png')
    },
    randomImg: {
      type: String,
      default: require('../assets/tree/random.png')
    }
  },

  data() {
    return {
      defaultProps: {
        children: "subList",
        label: "departmentName"
      },
      filterText: '',
      id: this.departmentId,
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  created() {
  },

  mounted() {
    // 默认选择第一个支队
    this.$bus.on('defaultSelectFristTwoDeptment', v => {
      this.id = v
      this.$nextTick(() => {
        if (this.$refs.tree != undefined) this.$refs.tree.setCurrentKey(v)
      })
    })
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.departmentName.indexOf(value) !== -1;
    },
    
    /* 点击变更部门 */
    handleNodeClick(data) {
      this.id = Number(data.id);
      this.mapId(this.companyList, data.id)
      this.$emit('selectTreeNodeList', data)
    },

    mapId(child, id) {
      child.map(i => {
        if (i.id === id) {
          if (i.level === 1) {
            i.img = this.isSwitchImg?this.firstHighImg:this.bookImg
          } else {
            i.img = this.isSwitchImg?this.secondHighImg:this.randomImg
          }
          i.threeSpotImg = this.threeSpotHighImg
        } else {
          if (i.level === 1) {
            i.img = this.isSwitchImg?this.firstImg:this.bookImg
          } else {
            i.img = this.isSwitchImg?this.secondImg:this.randomImg
          }
          i.threeSpotImg = this.threeSpotImg
        }
        if (i.subList && i.subList.length > 0) {
          this.mapId(i.subList, id);
        }
      })
    },
  }
}
</script>

<style lang='scss'>
.tree {
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $bg-ChangeDepartmentHighTree;
    color: $color-ChangeDepartmentHighTree;
  }
  .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    font-size: $fs-small-l;
    color: $color-grey;
  }
  .search {
    margin-bottom: 12px;
  }
  
  .system-preset {
    color: $color-ChangeDepartmentHighTree;
  }
  .custom-tree-node {
    width: 100%;
    @include flex-between;
    padding-right: 20px;
    .threeSpotImg {
      @include extend-click;
    }
  }
}
</style>
